import React from 'react'
import { useTranslation } from 'react-i18next'

import translations from '@translationKeys'

import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import { IconButton } from '@mui/material'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'

interface ChatOptionsMenuProps {
  onMarkAsUnread: () => void
  onGoToProfile: () => void
}

const ChatOptionsMenu: React.FC<ChatOptionsMenuProps> = ({ onMarkAsUnread, onGoToProfile }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleMarkAsUnreadClick = () => {
    handleClose()
    onMarkAsUnread()
  }
  const handleGoToProfileClick = () => {
    handleClose()
    onGoToProfile()
  }

  const { t } = useTranslation()

  return (
    <>
      <IconButton size="small" onClick={handleClick}>
        <MoreHorizIcon fontSize="inherit" />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {/* <MenuItem onClick={handleDeleteClick}>{t(translations.MENU_DELETE)}</MenuItem> */}
        <MenuItem onClick={handleMarkAsUnreadClick}>{t(translations.MENU_UNREAD)}</MenuItem>
        <MenuItem onClick={handleGoToProfileClick}>{t(translations.MENU_PROFILE)}</MenuItem>
      </Menu>
    </>
  )
}

export default ChatOptionsMenu
